import React, {Component} from "react"
// Circular deps means we have to access helpers directly
import getMessage from "@irati/utils/lang/helpers/getMessage"
import {injectIntl, InjectIntlProps} from "@irati/utils/lang/injectIntl"
import {getErrorValues} from "@irati/utils/lang/formatError"
import ErrorText from "../ErrorText"
import {ErrorProps} from "."

interface Props extends ErrorProps, InjectIntlProps {}

class LoadingError extends Component<Props> {
  render() {
    const {error, formatMessage, errorMsg} = this.props
    return <ErrorText {...this.props}>{getMessage(formatMessage, errorMsg, getErrorValues(error))}</ErrorText>
  }
}

export default injectIntl(LoadingError)
